import React from 'react';

interface CardListProps<T> {
    items: T[];
    renderCard: (item: T, index: number) => React.ReactNode;
    className?: string;
    emptyMessage?: string;
    columns?: 2 | 3; // Suporte para 2 ou 3 colunas
}

function CardList<T>({ items, renderCard, className = '', emptyMessage = 'Nenhum item encontrado', columns = 2 }: CardListProps<T>) {
    if (items.length === 0) {
        return (
            <div className="flex items-center justify-center py-12">
                <p className="text-gray-500 text-lg">{emptyMessage}</p>
            </div>
        );
    }

    const gridCols = columns === 3 ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1 lg:grid-cols-2';

    return (
        <div className={`grid ${gridCols} gap-4 ${className}`}>
            {items.map((item, index) => (
                <div key={index}>
                    {renderCard(item, index)}
                </div>
            ))}
        </div>
    );
}

export default CardList;
